var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SubContentTemplate',{attrs:{"isFull":true},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('BoardMain',{attrs:{"adminMode":false}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }